import {  CHECK_LOGIN } from "../actions/constantsActions";

const initialState = {};

export default function configs(state = initialState, action) {
  
	if (action.type === CHECK_LOGIN) {
	  return action.checkLogin;
	}
  return state;
}


